/**
 * This is a wrapper component for different Layouts.
 * Navigational 'aside' content should be added to this wrapper.
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink, TabNav } from '../../components';

import css from './LayoutWrapperSideNav.css';

const LayoutWrapperSideNav = props => {
  const { className, rootClassName, children, tabs, user } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <aside className={classes}>
      {tabs ? <TabNav user={user} selectedClass={css.selectedClass} linkClass={css.customLink} rootClassName={css.tabs} tabRootClassName={css.tab} tabs={tabs} /> : null}
      {user && user.id ? (
        <NamedLink
          className={css.profileLink}
          name="ProfilePage"
          params={{ id: user.id.uuid }}
        >
          <FormattedMessage id="LayoutWrapperSideNav.viewProfileLink" />
        </NamedLink>
      ) : null}
      {children}
    </aside>
  );
};

LayoutWrapperSideNav.defaultProps = {
  className: null,
  rootClassName: null,
  children: null,
  tabs: null,
};

const { node, string, array } = PropTypes;

LayoutWrapperSideNav.propTypes = {
  children: node,
  className: string,
  rootClassName: string,
  tabs: array,
};

export default LayoutWrapperSideNav;
